import { CountriesEnum } from '../../model/hros/common/codelist/CountryCodeList';

function FormatUSAAddress(address?: string, city?: string, state?: string, postalCode?: string) : string | undefined 
{
  if (address === undefined && city === undefined && state === undefined && postalCode === undefined) {
    return undefined;
  }

  let formattedAddress: string[] = [];

  if (address !== undefined) {
    formattedAddress.push(address.trim());
  }

  if (city !== undefined) {
    if (state !== undefined) {
      formattedAddress.push(`${city.trim()}, ${state.trim()}`);
    }
    else {
      formattedAddress.push(city.trim());
    }
  }

  if (state !== undefined && city === undefined) {
    formattedAddress.push(state.trim());
  }

  if (postalCode !== undefined) {
    formattedAddress.push(postalCode.trim());
  }

  if (formattedAddress.length === 0) {
    return undefined;
  }

  return formattedAddress.join(' ');
}

function FormatOtherAddress(address?: string, city?: string, postalCode?: string, country?: string) : string | undefined {  
  if (address === undefined && city === undefined && postalCode === undefined && country === undefined) {
    return undefined;
  }

  let formattedAddress: string[] = [];

  if (address !== undefined) {
    formattedAddress.push(address.trim());
  }

  if (city !== undefined) {
    formattedAddress.push(city.trim());
  }

  if (postalCode !== undefined) {
    formattedAddress.push(postalCode.trim());
  }
  
  if (country !== undefined) {
    formattedAddress.push(country.trim());
  }

  if (formattedAddress.length === 0) {
    return undefined;
  }

  return formattedAddress.join(' ');
}

export function FormatAddress(address?: string, city?: string, state?: string, postalCode?: string, country?: string) : string | undefined {
  if (address === undefined && city === undefined && state === undefined && postalCode === undefined && country === undefined) {
    return undefined;
  }

  if (country === undefined || country === CountriesEnum.US) {
    return FormatUSAAddress(address, city, state, postalCode);
  }
  
  return FormatOtherAddress(address, city, postalCode, country);
}